export default __webpack_public_path__ + "static/media/img-slider-banpu-power-1.19562a27.png";